/**
 * Merges saved selectedIds onto an empty shape; keeps only known keys as arrays.
 */
export function mergeSelectedIdMap(saved, emptySelectedIds) {
  const merged = { ...emptySelectedIds };

  if (!saved || typeof saved !== "object") {
    return merged;
  }

  Object.keys(emptySelectedIds).forEach((key) => {
    if (Array.isArray(saved[key])) {
      merged[key] = saved[key].filter((value) => value != null && value !== "");
    }
  });

  return merged;
}
